/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link, useNavigate } from "react-router";

import { OrganisationCardDetailProps } from "@models/components/organisation.model";
import { LocalizationObjectType } from "@models/utils/localisation.models";
import { applyLocalization } from "@services/common.service";

const OrganisationCardDetail: React.FC<OrganisationCardDetailProps> = ({
  address,

  clubId,
  mobileLogo,
  name,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="fg-card-block"
      onClick={() => {
        navigate(`/organisation-info/${clubId}/booking`);
      }}
      data-testid="organisation-details-card"
    >
      {mobileLogo && (
        <div className={`fg-card-img ${!mobileLogo ? "fg-icon-light" : ""}`}>
          {mobileLogo && <img src={mobileLogo} alt="" />}
        </div>
      )}
      <div className="fg-card-details">
        <div className="d-flex flex-column">
          <div className="fg-card-title">
            <Link to="">
              {" "}
              {applyLocalization(name || ({} as LocalizationObjectType))}
            </Link>
          </div>
          <div className="fg-card-sub-title">
            {address?.street}
            {address?.zipcode && address?.street && ", "}
            {address?.zipcode}
            {address?.location && address?.zipcode && ", "}
            {""} {address?.location}
          </div>
        </div>
      </div>
    </div>
  );
};
export default OrganisationCardDetail;
